$("#file_upload_1").fineUploader({
    template: 'qq-template',
    request: {
        endpoint: 'fine-uploader/endpoint.php'
    },
    validation: {
        allowedExtensions: ['jpeg', 'jpg', 'gif', 'png'],
        itemLimit: 1
    },          
    debug: false,
    deleteFile: {
        enabled: true,
        endpoint: 'data/'
    }
});